import { render, staticRenderFns } from "./comment-summary.vue?vue&type=template&id=bf7183fa&scoped=true"
import script from "./comment-summary.vue?vue&type=script&lang=js"
export * from "./comment-summary.vue?vue&type=script&lang=js"
import style0 from "./comment-summary.vue?vue&type=style&index=0&id=bf7183fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7183fa",
  null
  
)

export default component.exports